/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'anger',
    quality: 0,    
    perception: -3,
    learning: -3,    
    willpower: 3
}